import { z } from 'zod';

import { paymentSessionSchema } from '@/features/payment-session/public';

export const investorEntryResolutionSchema = z.discriminatedUnion('action', [
  z.object({
    action: z.literal('login'),
    data: z.object({ pan: z.string(), investorId: z.string().optional() }),
  }),
  z.object({
    action: z.literal('onboard'),
    data: z.object({ paymentSession: paymentSessionSchema, investorId: z.string().optional() }),
  }),
]);
